import { render, staticRenderFns } from "./corporate-sponsored-add-tier.vue?vue&type=template&id=f8e0f0f8&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports